import React from 'react';
import { mergeProps } from 'next-merge-props';

import { IPage } from '@/types/contentful';

import { getServerSideSearchProps } from '../../modules/learning-center/getServerSideSearchProps';
import { getServerSideCookieProps } from '../../modules/cookies/getServerSideCookieProps';

import { PageProps } from '../../context/PageData';

import { Body } from '../../components/Body';
import { PageBlocks } from '../../components/Page/PageBlocks';
import { HeroBlock } from '../../components/Page/HeroBlock';
import { ArticleSectionBlock } from '../../components/LearningCenter/Components/ArticleSectionBlock';

export default function SearchPage({ pageData }: PageProps) {
  const { fields } = (pageData as IPage) ?? {};

  // @TODO: Fix undefined should be string
  return (
    <Body {...fields} bgColor="#F3F3F3">
      <HeroBlock {...fields} />
      <PageBlocks {...fields} />
      <ArticleSectionBlock
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        title={undefined as any}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        category={undefined as any}
        lazyLoad={true}
      />
    </Body>
  );
}

export const getServerSideProps = mergeProps([
  getServerSideSearchProps,
  getServerSideCookieProps
]);
